module.exports = __webpack_public_path__ + "static/img/smartstation44.298e8b7e.png";